export { default as Faq } from './Faq'
